// 提取url中的解析参数
function UrlParamHash(url) {
  let res = {};
  let params = url.split('#')[0].slice(url.indexOf("?") + 1).split('&');

  for (let i = 0; i < params.length; i++) {
    let h = params[i].split("=");
    if (h[1]) {
      res[h[0]] = h[1];
    }
  }
  return res;
}

export default async (app) => {
  let device = app.helper.screen.isPC ? "pc" : "phone";
  let params = UrlParamHash(location.href)
  const profile = app.CORE_PROFILE ? app.CORE_PROFILE : await app.curl.get("api/core/profile", { device, ...params });

  //拆到coreWeb 的获取方法
  let layoutSetting = {}
  // if (profile.pkgcfg.coreweb) {
  //   layoutSetting = profile.pkgcfg.coreweb.layoutSetting;
  // }
  // console.log(profile.layout,'----------');

  console.log("profile info", profile);

  app.layout.defaultLayout = app.layout.findLayout(profile.layout); //store的布局对象
  app.store.commit("core/setLayout", profile.layout);
  app.store.commit("core/setUser", profile.user);
  app.store.commit("core/setThema", profile.thema); //cookie中有就读cookie
  app.store.commit("core/setUserding", profile.layoutUserDing);
  app.store.commit("core/setPC2SideBarImg", layoutSetting); //pc2布局侧边栏背景图
  app.store.commit("core/setTopImg", layoutSetting); //top布局侧边栏背景图
  app.store.dispatch("core/setLogoface", profile.thema); //top布局侧边栏背景图
  app.store.commit("core/isUiStyle", profile.isUiStyle); //是否自定义 ui界面 
  app.store.commit("core/setMenuKey", profile.menuKey); //自定义 选中ui菜单key值
  // app.store.commit("core/setUistyle", profile.uistyle); //自定义ui界面配置
  app.store.commit("core/setHeadline", profile.headline); //自定义ui界面配置
  app.store.commit("core/setUiKey", profile.uiKey); //自定义ui界面配置

  // app.Cfg = profile.pkgcfg;
  // profile.projsetting.isCryptoLoginPWD = true// 测试
  app.ProjSetting = { ...profile.projsetting };
  app.Setting.core = profile.coresetting; //获取系统设置
  app.uiStyle = {
    key: profile.uiKey,
    layout: profile.layout,
    menu: profile.menuKey,
    thema: profile.thema,
    meta: profile.styleMeta
  }
  //表单前端草稿
  if (app.Vue.prototype.$formDraftClass)
    app.Vue.prototype.$formdraft = new app.Vue.prototype.$formDraftClass(app.ProjSetting.code, profile.user.userid)


  app.user = profile.user;//直接把个人信息存到app的userinfo里面去,根本务必要放在Vuex上不具备联动需求
  app.userPids = profile.userPids; //个人拥有的权限
  app.userRoles = profile.userRoles; //个人拥有的权限
  if (profile.menus.length === 0) {
    window.alert(`对不起，当前用户无任何菜单权限，请联系管理员。`)
    throw new Error(`${profile.user.cnname || profile.user.username}无任何菜单权限，请联系管理员.`);
  }

  //连接socketio
  if (profile.socket && app.Cfg.core.system.SOCKETIO_CLIENT_ENABLE == 1) {

    await app.io.connect(app).then(res => {
      console.log("%c" + "socket connected:" + res.id, "color:blue");
    });
  }

  app.menus = profile.menus;
};
